import { ProductEntitiesEndpoint as ProductsEntitiesEndpointInterface } from '@apiClient/interfaces/endpoints/ProductEntities.endpoint';
import { buildSearchParams } from '@/utils/handlers/urlHandler';
import { KyInstance } from "ky/distribution/types/ky";
import { KyResponse } from 'ky';
import ApiResponseDto from '@/projectRoot/api-client/interfaces/response/ApiResponse.dto';
import PaginationDto from '@/projectRoot/api-client/interfaces/request/Pagination.dto';
import CategoryDto from '@/projectRoot/api-client/interfaces/models/products/product-entities/Category.dto';
import BrandDto from '@/projectRoot/api-client/interfaces/models/products/product-entities/Brand.dto';
import LabelDto from '@/projectRoot/api-client/interfaces/models/products/product-entities/Label.dto';
import ColorDto from '@/projectRoot/api-client/interfaces/models/products/product-entities/Color.dto';
import CollectionDto from '@/projectRoot/api-client/interfaces/models/products/product-entities/Collection.dto';
import ProductEntitySearchDto from '@/projectRoot/api-client/interfaces/request/products/ProductEntitySearch.dto';

export class ProductEntitiesEndpoint implements ProductsEntitiesEndpointInterface {
   
    private _httpClient: KyInstance;
    private cache: RequestCache;

    public constructor(client: KyInstance, cache: RequestCache = process.env.NEXT_PUBLIC_ENVIRONMENT == 'staging' ? "no-store" : "force-cache") {
        this._httpClient = client;
        this.cache = cache;
    }

    get httpClient(): KyInstance {
        if (!this._httpClient) {
            throw new Error('Ky http client is not initialized');
        }
        return this._httpClient;
    }

    set httpClient(kyInstance: KyInstance) {
        this._httpClient = kyInstance;
    }


    async categoriesSearch(params?: ProductEntitySearchDto): Promise<ApiResponseDto<CategoryDto[], PaginationDto>> {
        return this._httpClient
            .get(`products/categories`, { searchParams: params ? buildSearchParams(params) : {}, cache: this.cache })
            .then((response: KyResponse) => {
                if (response.status < 200 || response.status > 299) {
                    throw new Error(response.statusText)
                }
                return response.json();
            });
    }

    async categoriesSingle(id: string): Promise<ApiResponseDto<CategoryDto, undefined>> {
        return this._httpClient
            .get(`products/categories/${id}`, { cache: this.cache })
            .then((response: KyResponse) => {
                if (response.status < 200 || response.status > 299) {
                    throw new Error(response.statusText)
                }
                return response.json();
            });
    }

    async brandsSearch(params?: ProductEntitySearchDto): Promise<ApiResponseDto<BrandDto[], PaginationDto>> {
        return this._httpClient
            .get(`products/brands`, { searchParams: params ? buildSearchParams(params) : {}, cache: this.cache })
            .then((response: KyResponse) => {
                if (response.status < 200 || response.status > 299) {
                    throw new Error(response.statusText)
                }
                return response.json();
            });
    }

    async brandsSingle(id: string): Promise<ApiResponseDto<BrandDto, undefined>> {
        return this._httpClient
            .get(`products/brands/${id}`, { cache: this.cache })
            .then((response: KyResponse) => {
                if (response.status < 200 || response.status > 299) {
                    throw new Error(response.statusText)
                }
                return response.json();
            });
    }

    async labelsSearch(params?: ProductEntitySearchDto): Promise<ApiResponseDto<LabelDto[], PaginationDto>> {
        return this._httpClient
            .get(`products/labels`, { searchParams: params ? buildSearchParams(params) : {}, cache: this.cache })
            .then((response: KyResponse) => {
                if (response.status < 200 || response.status > 299) {
                    throw new Error(response.statusText)
                }
                return response.json();
            });
    }

    async labelsSingle(id: string): Promise<ApiResponseDto<LabelDto, undefined>> {
        return this._httpClient
            .get(`products/labels/${id}`, { cache: this.cache })
            .then((response: KyResponse) => {
                if (response.status < 200 || response.status > 299) {
                    throw new Error(response.statusText)
                }
                return response.json();
            });
    }

    async colorsSearch(params?: ProductEntitySearchDto): Promise<ApiResponseDto<ColorDto[], PaginationDto>> {
        return this._httpClient
            .get(`products/colors`, { searchParams: params ? buildSearchParams(params) : {}, cache: this.cache })
            .then((response: KyResponse) => {
                if (response.status < 200 || response.status > 299) {
                    throw new Error(response.statusText)
                }
                return response.json();
            });
    }

    async colorsSingle(id: string): Promise<ApiResponseDto<ColorDto, undefined>> {
        return this._httpClient
            .get(`products/colors/${id}`, { cache: this.cache })
            .then((response: KyResponse) => {
                if (response.status < 200 || response.status > 299) {
                    throw new Error(response.statusText)
                }
                return response.json();
            });
    }

    async collectionsSearch(params?: ProductEntitySearchDto): Promise<ApiResponseDto<CollectionDto[], PaginationDto>> {
        return this._httpClient
            .get(`products/collections`, { searchParams: params ? buildSearchParams(params) : {}, cache: this.cache })
            .then((response: KyResponse) => {
                if (response.status < 200 || response.status > 299) {
                    throw new Error(response.statusText)
                }
                return response.json();
            });
    }

    async collectionsSingle(id: string): Promise<ApiResponseDto<CollectionDto, undefined>> {
        return this._httpClient
            .get(`products/collections/${id}`, { cache: this.cache })
            .then((response: KyResponse) => {
                if (response.status < 200 || response.status > 299) {
                    throw new Error(response.statusText)
                }
                return response.json();
            });
    }

}

export default ProductEntitiesEndpoint;